import { createContext, useContext } from 'react';
import useWishlist from '../hooks/useWishlist';

/**
 * Wishlist Context
 *
 * Provides global access to wishlist state and methods
 */
const WishlistContext = createContext(null);

/**
 * WishlistProvider Component
 *
 * Wraps the app to provide wishlist state to all components
 */
export const WishlistProvider = ({ children }) => {
  const wishlist = useWishlist();

  return (
    <WishlistContext.Provider value={wishlist}>
      {children}
    </WishlistContext.Provider>
  );
};

/**
 * useWishlistContext Hook
 *
 * Custom hook to access wishlist context
 * Must be used within WishlistProvider
 */
export const useWishlistContext = () => {
  const context = useContext(WishlistContext);
  if (!context) {
    throw new Error('useWishlistContext must be used within WishlistProvider');
  }
  return context;
};

export default WishlistContext;
